import { mergeClasses } from '@fluentui/react-components';
import MetricsTable, { IMetricsTableProps } from '../MetricsTable/MetricsTable';
import {
    ResponsiveChildProps,
    ResponsiveContainer,
} from '@fluentui/react-charts';
import { useChartStyles } from './TableChart.styles';

interface TableChartProps {
    chart: React.ReactElement<ResponsiveChildProps>;
    tableProps: IMetricsTableProps;
}

const TableChart: React.FC<TableChartProps> = ({ chart, tableProps }) => {
    const styles = useChartStyles();

    return (
        <div className={styles.container}>
            <div className={styles.chartContainer}>
                <ResponsiveContainer>{chart}</ResponsiveContainer>
            </div>
            <MetricsTable
                {...tableProps}
                className={mergeClasses(
                    styles.chartTable,
                    tableProps.className
                )}
            />
        </div>
    );
};

export default TableChart;
